import React from 'react';
export default function ReminderCard() {

    const reminders = [
        {label: 'Expire soon', count: 4, tone: 'warning'},
        {label: 'Already expired', count: 2, tone: 'danger'},
        {label: 'Up to date', count: 27, tone: 'success'}
    ];
    return (
        <div className="flex gap-1 card  h-full">

            <div className="w-5 ">
                {/* PrimeFlex centering */}
                <div className="flex h-full align-items-center justify-content-center">
                    <i
                        className="pi pi-exclamation-triangle"
                        aria-hidden="true"
                        style={{fontSize: 80, color: 'var(--yellow-600)'}}
                    />
                </div>
            </div>

            <div className="w-7 pl-3">
                <div>
                    <span className="font-semibold text-lg">Reminder</span>
                </div>

                <ul className="list-none p-0 m-0 flex flex-column gap-2 mt-3">
                    {reminders.map((r) => {
                        const colorClass =
                            r.tone === 'danger'
                                ? 'text-red-500'
                                : r.tone === 'warning'
                                    ? 'text-yellow-600'
                                    : 'text-green-500';
                        return (
                            <li key={r.label} className="flex justify-content-between align-items-center">
                                <div className="flex align-items-center">
                                    <i className={`pi pi-circle ${colorClass} mr-3`} aria-hidden="true" />
                                    <div>
                                        <div className="text-gray-700 font-semibold">{r.label}</div>
                                    </div>
                                </div>
                                <div className="text-gray-900 font-bold">{r.count}</div>
                            </li>
                        );
                    })}
                </ul>

            </div>
        </div>
    );
}
